export default "__VITE_ASSET__2pQLP_Mg__"